export default __webpack_public_path__ + "static/media/google_icon.184c0c59.svg";